import { Directive, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { injectCurrentUser } from '@assist/shared/data';

@Directive({
  selector: '[assistControlMonitorEnabled], [*assistControlMonitorEnabled]',
  standalone: true,
})
export class AssistControlMonitorEnabledDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private currentUser = injectCurrentUser();

  ngOnInit() {
    if (this.currentUser()?.data?.features.assistControlMonitor) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
